import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Fornecedor } from '../../types/aquisicao';
import {
  certificacoesService,
  enderecosService,
  fornecedoresService,
  tiposEntidadeService,
  tiposMadeiraService,
} from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Fornecedor>[] = [
  { name: 'razao_social', label: 'Razão social', required: true },
  { name: 'nome_fantasia', label: 'Nome fantasia' },
  {
    name: 'tipo_pessoa',
    label: 'Tipo de pessoa',
    type: 'select',
    options: [
      { label: 'Pessoa jurídica', value: 'PJ' },
      { label: 'Pessoa física', value: 'PF' },
    ],
    required: true,
  },
  { name: 'documento', label: 'Documento (CPF/CNPJ)' },
  { name: 'numero', label: 'Número', required: true },
  {
    name: 'tipos',
    label: 'Tipos de entidade',
    type: 'async-select',
    multiple: true,
    valueType: 'number[]',
    loadOptions: makeOptionLoader(
      tiposEntidadeService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
    helperText: 'Inclua FORNECEDOR para habilitar nas telas de aquisição.',
  },
  {
    name: 'tipos_madeira',
    label: 'Tipos de madeira',
    type: 'async-select',
    multiple: true,
    valueType: 'number[]',
    loadOptions: makeOptionLoader(
      tiposMadeiraService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
  },
  {
    name: 'certificacoes',
    label: 'Certificações',
    type: 'async-select',
    multiple: true,
    valueType: 'number[]',
    loadOptions: makeOptionLoader(
      certificacoesService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
  },
  { name: 'telefone', label: 'Telefone' },
  { name: 'email', label: 'E-mail', type: 'email' },
  {
    name: 'endereco',
    label: 'Endereço',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      enderecosService.list,
      (item: any) => {
        const partes = [item.logradouro, item.bairro, item.cidade_nome, item.cep].filter(Boolean);
        return partes.length ? partes.join(', ') : `Endereço #${item.id}`;
      },
    ),
    helperText: 'Selecione um endereço cadastrado.',
  },
];

export const FornecedoresFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo fornecedor"
    description="Cadastre um novo fornecedor de madeira."
    fields={fields}
    service={fornecedoresService}
    redirectPath="/admin/aquisicao/fornecedores"
    cancelPath="/admin/aquisicao/fornecedores"
  />
);
